import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Select } from 'modules/filters/utils';

import { getFilteredRoutes } from 'reselects';

import { isLocalOrCorridorAndDefinedAndEnabled } from 'reselects/routes';
import { LH_EXPRESS_ROUTE_FOR_FILTER, LH_EXPRESS_FR_ROUTE_FOR_FILTER } from 'utils/lhexpress';
import {
  INTERNATIONAL_ROUTE_FOR_FILTER,
  sanitizeInternationalSelection,
} from 'utils/international';

import { injectIntl } from 'react-intl';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';

const RouteFilter = ({ value, onChange, className, intl }) => {
  const routes = useSelector((state) =>
    getFilteredRoutes(state, isLocalOrCorridorAndDefinedAndEnabled)
  );
  const t = intl.messages.modules.Filters.route;
  const routesWithExtras = [
    ...routes,
    LH_EXPRESS_ROUTE_FOR_FILTER,
    LH_EXPRESS_FR_ROUTE_FOR_FILTER,
    INTERNATIONAL_ROUTE_FOR_FILTER,
  ];

  const isLhFilterEnabled = useSelector((store) =>
    getSpecificClientConfig(store, constants.LH_FILTER)
  );
  // It is assumed that if the LH filter is enabled, the International filter must also be enabled
  const routeOptions = isLhFilterEnabled ? routesWithExtras : routes;

  const options = (routeOptions || []).map((route) => ({
    label: route?.simple_name,
    value: route?.simple_name,
  }));

  const handleChange = useCallback(
    (value, actionMeta) => {
      if (!onChange) {
        return;
      }

      onChange(sanitizeInternationalSelection(value, actionMeta));
    },
    [onChange]
  );

  return (
    <div className={className} data-testid="route_filter">
      <Select
        value={value}
        closeMenuOnSelect={false}
        options={options}
        isMulti
        onChange={handleChange}
        placeholder={t.placeholder}
      />
    </div>
  );
};

export default injectIntl(RouteFilter);
